module.exports = __webpack_public_path__ + "media/images/actor_ogp_image/new_face-3d413ed7595528b33bb4a959968228a8.png";